module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.3a54041d.webp";